import React from "react";
import Konva from "konva";
import { Button, ButtonGroup, DropdownButton } from "./toolbar-buttons";
import * as icons from "frontend/icons/icons";
import toolbar_styles from "./elements-toolbar.module.css";
import { AlignmentFns, AlignmentTypes, distributeH, distributeV } from "frontend/utils/alignment-utils";
import cn from "classnames";

const ICON_SIZE = 20;
const ICON_COLOR = "white";

export function AlignmentButton({
  nodes,
  setNodePosition,
  onMutationEnd,
}: {
  nodes: Konva.Node[];
  setNodePosition: (id: string, pos: { x: number; y: number }) => void;
  onMutationEnd: (e: any) => void;
}) {
  function onAlign(evt: any) {
    const align = (evt.currentTarget as HTMLButtonElement).dataset.align;
    if (align && align in AlignmentFns) {
      const movementData = AlignmentFns[align as AlignmentTypes](nodes);
      for (const move of movementData) {
        move.node.fire("transformstart"); // save props for undo
        setNodePosition(move.node.id(), move.target);
      }
      // HACK: I can only record the mutation after the elements moved, which does not
      // happen in this frame.
      // we really should have a way of scheduling an action for next subscription (updated elements)
      setTimeout(onMutationEnd, 50); // record the operation in the undo stack
    } else {
      console.error("alignment button isn't configured correctly");
    }
  }

  function onDistributeH() {
    const moveData = distributeH(nodes);
    for (const move of moveData) {
      move.node.fire("transformstart");
      setNodePosition(move.node.id(), move.target);
    }
    // HACK: I can only record the mutation after the elements moved, which does not
    // happen in this frame.
    // we really should have a way of scheduling an action for next subscription (updated elements)
    setTimeout(onMutationEnd, 50); // record the operation in the undo stack
  }

  function onDistributeV() {
    const moveData = distributeV(nodes);
    for (const move of moveData) {
      move.node.fire("transformstart");
      setNodePosition(move.node.id(), move.target);
    }
    // HACK: I can only record the mutation after the elements moved, which does not
    // happen in this frame.
    // we really should have a way of scheduling an action for next subscription (updated elements)
    setTimeout(onMutationEnd, 50); // record the operation in the undo stack
  }

  return (
    <DropdownButton
      tooltip="Align objects"
      renderPopup={() => (
        <div className={cn(toolbar_styles.miniToolbarLayout, toolbar_styles.withSeparators)}>
          <ButtonGroup>
            <Button onClick={onAlign} data-align="left" tooltip="Align left">
              <icons.AlignLeft size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
            <Button onClick={onAlign} data-align="hcenter" tooltip="Align horizontal centers">
              <icons.AlignHCenter size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
            <Button onClick={onAlign} data-align="right" tooltip="Align right">
              <icons.AlignLeft mirrored={true} size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button onClick={onAlign} data-align="top" tooltip="Align top">
              <icons.AlignTop size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
            <Button onClick={onAlign} data-align="vcenter" tooltip="Align vertical centers">
              <icons.AlignVCenter size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
            <Button onClick={onAlign} data-align="bottom" tooltip="Align bottom">
              <icons.AlignTop flipped={true} size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button onClick={onDistributeH} tooltip="Distribute horizontally">
              <icons.DistributeHorizontal size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
            <Button onClick={onDistributeV} tooltip="Distribute vertically">
              <icons.DistributeVertical size={ICON_SIZE} color={ICON_COLOR} />
            </Button>
          </ButtonGroup>
        </div>
      )}
      arrowSize={12}
      className={toolbar_styles.miniToolbarPopup}
    >
      <icons.AlignHCenter size={ICON_SIZE} />
    </DropdownButton>
  );
}
